import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const updateUserStateSlice = getBulkActionSlice(
    'updateUserStateResult',
);

export const selectUpdateUserStateShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.updateUserStateResult.shown;

export const selectUpdateUserStateBulkUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.updateUserStateResult.uuid;

export const selectUpdateUserStateTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.updateUserStateResult.backgroundTask;

export const {
    setUuid,
    setBackgroundTask,
    setShown,
    clearResult,
} = updateUserStateSlice.actions;
